import dayjs from 'dayjs';
import React from 'react';
import { StyledWrapper } from './styles';

function ContactOverview({ contact }) {
  const handleFormatSignUpDate = (d) => (d ? dayjs(d).format('MMM D, YYYY') : '-');

  return (
    <StyledWrapper>
      {/* Title */}
      <div className="flex-row-end mb-2">
        <div className="customer-name">
          {contact?.first_name}
          {' '}
          {contact?.last_name}
        </div>
      </div>

      {/* Customer Details */}
      <div className="details-title">Contact details</div>
      <div className="details-grid">
        <div className="details-cell">
          <div className="details-cell-left">Email</div>
          <div className="details-cell-right details-cell-colored strong">
            {contact.email}
          </div>
        </div>
        <div className="details-cell">
          <div className="details-cell-left">Phone</div>
          <div className="details-cell-right">
            {contact.phone}
            {' '}
          </div>
        </div>

        <div className="details-cell">
          <div className="details-cell-left">Signup date</div>
          <div className="details-cell-right">
            {handleFormatSignUpDate(contact.created_at)}
          </div>
        </div>

        {
          contact.source && (
            <div className="details-cell">
              <div className="details-cell-left">Origin</div>
              <div className="details-cell-right">
                {contact.source}
              </div>
            </div>
          )
        }
      </div>
    </StyledWrapper>
  );
}

export default ContactOverview;
